import { Table } from 'common/components/Table/Table'
import { DEFAULT_TABLE_PARAMS } from 'common/constants/defaultTableParamsConstants'
import type { TableParamsType } from 'common/interfaces/ITable'
import type { ObjectType } from 'common/interfaces/object'
import { useFetchPrescriptionsQuery } from 'features/Procedure/state/procedure.api'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { prescriptionsTableColumns } from './columns'
import type { IPrescription } from './prescriptions.types'
import styles from './prescriptions.module.scss'

type PrescriptionsProps = {
  selectedPatientId: number | null
}

export const Prescriptions = ({ selectedPatientId: patientId }: PrescriptionsProps) => {
  const [columns, setColumns] = useState<ObjectType[]>([])
  const [tableParams, setTableParams] = useState<TableParamsType>({
    ...DEFAULT_TABLE_PARAMS,
  })
  // const [isManagePrescriptionVisible, toggleManagePrescription] = useToggle(false)

  const { data: prescriptionsData, isLoading } = useFetchPrescriptionsQuery(
    { patientId: patientId ?? 0 },
    { skip: !patientId },
  )

  const handleDrugClick = useCallback((prescription: IPrescription) => {
    // Handle drug click - can be extended later
    console.log('Prescription clicked:', prescription)
  }, [])

  useEffect(() => {
    setColumns(prescriptionsTableColumns(handleDrugClick))
  }, [handleDrugClick])

  const transformedData = useMemo(() => {
    if (!prescriptionsData) return []
    return prescriptionsData.map((prescription) => {
      // Combine dosage and note for details, or use note if available
      const details = prescription.note
        ? prescription.note
        : prescription.dosage
        ? `${prescription.dosage}${prescription.size ? ` ${prescription.size}` : ''}`
        : ''

      return {
        id: prescription.id,
        drug: prescription.drug,
        details,
        qty: prescription.quantity ? Number(prescription.quantity) : 0,
        refills: prescription.refills ?? 0,
        filled: prescription.date_added || prescription.start_date || '',
      } as IPrescription
    })
  }, [prescriptionsData])

  useEffect(() => {
    setTableParams((prev) => ({ ...prev, total: transformedData.length }))
  }, [transformedData.length])

  useEffect(() => {
    if (tableParams.sorters) {
      setColumns((prev) =>
        prev.map((column) => ({
          ...column,
          sortOrder: tableParams.sorters?.[column.key]?.order,
        })),
      )
    }
  }, [tableParams.sorters])

  // const handleAddPrescription = useCallback(() => {
  //   toggleManagePrescription(true)
  // }, [toggleManagePrescription])

  // const handleCloseManagePrescription = useCallback(() => {
  //   toggleManagePrescription(false)
  // }, [toggleManagePrescription])

  return (
    <div className={styles.container}>
      {/* <ManagePrescriptionModal
        isVisible={isManagePrescriptionVisible}
        onClose={handleCloseManagePrescription}
      /> */}
      {/* <div className={styles.header}>
          <Button
            onClick={handleAddPrescription}
            severity={BUTTON_SEVERITY.SUCCESS_FILLED}
            icon={
              <div className={styles.iconWrapper}>
                <Icon icon='ph:plus' width={12} height={12} />
              </div>
            }>
            Add Prescription
          </Button>
        </div> */}
      <Table
        itemKey='id'
        tableParams={tableParams}
        dataSource={transformedData}
        setTableParams={setTableParams}
        columns={columns}
        isLoading={isLoading}
        haveActions={false}
        pagination={false}
      />
    </div>
  )
}
